import { instance } from '../instance'

export const deleteBeneficiary = async (id) => {
  return instance.delete(`/v1/beneficiary/${id}`)
}
